// Diagnose Mode: Standalone (Mode 1), VDR-invoked (Mode 2), and VDR multi-session (Mode 3).
// Mode 3 adds a `pid/:projectId` route pointing at the new project-session-management page.
import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';

/*
  Handle routes as:
  /workflow
  /workflow/:diagnosisId
  To manage routes related to solution-selector component
*/

export function solutionSelectorUrlMatcher(
  segments: UrlSegment[],
): UrlMatchResult | null {
  if (!segments.length) {
    return null;
  }

  const firstSegment = segments[0].path;

  // Handle 'workflow' (with or without diagnosisId)
  if (firstSegment === 'workflow') {
    if (segments.length === 1) {
      // Matches '/workflow'
      return { consumed: [...segments] };
    }
    if (segments.length === 2) {
      // Matches '/workflow/:diagnosisId'
      return {
        consumed: [...segments],
        posParams: { diagnosisId: segments[1] },
      };
    }
  }

  // Handle 'eid/:diagnosisId' and 'sid/:diagnosisId'
  if (firstSegment === 'sid' && segments.length === 2) {
    return { consumed: segments, posParams: { diagnosisId: segments[1] } };
  }

  return null;
}

export const WORKFLOW_ROUTES: Routes = [
  { path: '', redirectTo: '/workflow', pathMatch: 'full' },
  {
    path: 'diagnosis-complete/:diagnosisId',
    loadComponent: () =>
      import('./diagnosis-complete/diagnosis-complete.component').then(
        (c) => c.DiagnosisCompleteComponent,
      ),
  },
  // Mode 3 only. Landing page for a Mobius-created project. Identified purely by the projectId
  // URL segment — no `?source=vdr` query string required.
  {
    path: 'pid/:projectId',
    loadComponent: () =>
      import('./mode3-project/mode3-project.component').then(
        (c) => c.Mode3ProjectComponent,
      ),
  },
  {
    matcher: solutionSelectorUrlMatcher,
    loadComponent: () =>
      import('./solution-selector/solution-selector.component').then(
        (c) => c.SolutionSelectorComponent,
      ),
  },
];
